var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.000122042H1.5C1.30483 -0.00212607 1.11115 0.0343591 0.930169 0.107465C0.749191 0.180571 0.584511 0.288847 0.445659 0.426024C0.306807 0.563202 0.196542 0.726557 0.121247 0.906635C0.0459507 1.08671 0.00711926 1.27994 0.00699997 1.47512L0 10.3121C0.00103952 10.5075 0.0407455 10.7008 0.11683 10.8808C0.192914 11.0608 0.303872 11.224 0.443307 11.3609C0.582743 11.4979 0.7479 11.6058 0.929258 11.6786C1.11062 11.7514 1.30459 11.7876 1.5 11.7851H13.5C13.6954 11.7876 13.8894 11.7514 14.0707 11.6786C14.2521 11.6058 14.4173 11.4979 14.5567 11.3609C14.6961 11.224 14.8071 11.0608 14.8832 10.8808C14.9593 10.7008 14.999 10.5075 15 10.3121V1.47512C14.9992 1.27953 14.9597 1.08603 14.8837 0.905793C14.8078 0.725555 14.6969 0.56215 14.5574 0.425012C14.4179 0.287874 14.2527 0.179719 14.0712 0.106792C13.8897 0.0338656 13.6956 -0.00238879 13.5 0.000122042V0.000122042ZM13.5 10.3121H1.5V5.89212H13.5V10.3121ZM13.5 2.94612H1.5V1.47512H13.5V2.94612Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.66e268b264a0485455af56b3706dc27d.svg";
export { ForwardRef as ReactComponent };